"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AnimatedLoadingPulsingView;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _renderprops = require("react-spring/renderprops");
var _styles = require("@sart/styles");
var _excluded = ["loading", "style"];
var AnimatedView = (0, _renderprops.animated)(_reactNative.View);
var Container = _renderprops.Keyframes.Spring({
  show: {
    backgroundColor: _styles.colors.exisOrange
  },
  pulsing: function () {
    var _pulsing = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(next) {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!1) {
              _context.next = 3;
              break;
            }
            _context.next = 1;
            return next({
              backgroundColor: _styles.backgroundColors.subtle
            });
          case 1:
            _context.next = 2;
            return next({
              backgroundColor: _styles.backgroundColors.trivial
            });
          case 2:
            _context.next = 0;
            break;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function pulsing(_x) {
      return _pulsing.apply(this, arguments);
    }
    return pulsing;
  }()
});
function AnimatedLoadingPulsingView(props) {
  var loading = props.loading,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    state: loading ? "pulsing" : "show"
  }, function (styles) {
    return /*#__PURE__*/_react["default"].createElement(AnimatedView, (0, _extends2["default"])({
      style: _reactNative.StyleSheet.flatten([style, styles])
    }, rest));
  });
}
AnimatedLoadingPulsingView.defaultProps = {
  loading: true
};